// Check for cookie immediately on page load
if (document.cookie.indexOf("announcementDismissed=true") > -1) {
	// Hide announcement bar
	if (document.querySelector("#announcementBar")) {
		document.querySelector("#announcementBar").style.display = "none";
	}
}

// Add event listener to close icon
if (document.querySelector(".announcement-bar__close-icon")) {
	document.querySelector(".announcement-bar__close-icon").addEventListener("click", () => {
		// Hide announcement bar
		document.querySelector("#announcementBar").style.display = "none";

		// Set cookie with expiration date
		document.cookie = "announcementDismissed=true; expires=" + new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/";
	});
}
